import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '../shared/global';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { ROOT_URL } from '../shared/util/constants';

@Injectable()
export class AuthenticationService {
    constructor(private http: HttpClient) { }

   login(username: string, password: string, key_login: string, value_login: string): Observable<any> {        

       
        var data = {
          UserName: username, Password: password, key_login: key_login, value_login: value_login
        }
            let httpHeaders = new HttpHeaders()
            //.set('authorization','Bearer ' + this.token)
            .set('Content-Type', 'application/json')
            .set ('Access-Control-Allow-Origin', '*');
     
             return  this.http.post( Global.App_url + 'api/login/authenticate',data, {
                 headers: httpHeaders,                 
                 responseType: 'json' 
             });	  
        // var employee ={
        //     EmpId:'1',
        //     EmpName:'abc',
        // }
        //      const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        //     return this.http.post( 'http://localhost:65389/Api/Employee/InsertEmployeeDetails/', employee, httpOptions);
    }

   getlistkeylogin(username: string, password: string, key_login: string, value_login: string): Observable<any> {


      var data = {
        UserName: username, Password: password, key_login: key_login, value_login: value_login
      }
      let httpHeaders = new HttpHeaders()
        //.set('authorization','Bearer ' + this.token)
        .set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*');

        return this.http.post(Global.App_url + 'api/login/getlistkeylogin', data, {
        headers: httpHeaders,
        responseType: 'json'
      });
    
    }


    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
    }

    fcAuthenticate(functionRight: string, accessRight: number): Observable<any> {

        const headers = new HttpHeaders().set('content-type', 'application/json');
        var user = localStorage.getItem('currentUser');
        
        var body = {
            functionRight: functionRight, accessRight: accessRight, username: user.split(',')[1].split(':')[1]
        }

        return this.http.post(Global.App_url + 'api/login/fcAuthenticate', body);

        
    }

}
